export default __webpack_public_path__ + "static/media/msf_xl1.62997bdd.png";